const styles = theme => ({
    blockContainer:{
        minHeight: "250px",
        backgroundColor: theme.palette.background.default,
        color: theme.palette.text.primary,
        paddingTop: theme.spacing(4),
        paddingBottom: theme.spacing(4),
    },
    mainBlock:{
        textAlign: "center",
        paddingTop: theme.spacing(6),
        paddingBottom: theme.spacing(6),
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            paddingTop: theme.spacing(4),
            paddingBottom: theme.spacing(4),
            paddingLeft: theme.spacing(2),
            paddingRight: theme.spacing(2),
        }
    },
    eyebrow: {
        color: theme.palette.primary.main,
        fontWeight: 700,
        letterSpacing: '0.2em',
        marginBottom: theme.spacing(2),
    },
    heroLogo: {
        width: theme.spacing(14),
        height: theme.spacing(14),
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto',
        marginBottom: theme.spacing(3),
        [theme.breakpoints.down('sm')]: {
            width: theme.spacing(11),
            height: theme.spacing(11),
        }
    },
    mainTitleText:{
        maxWidth: "37rem",
        marginLeft: "auto",
        marginRight: "auto",
    },
    mainTitleDescription:{
        maxWidth: "44rem",
        paddingTop: "1.5rem",
        paddingBottom: "1.5rem",
        marginLeft: "auto",
        marginRight: "auto",
        color: theme.palette.text.secondary,
    },
    actionRow: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: theme.spacing(1.5),
        flexWrap: 'wrap',
    },
});

export default styles;
